export default function($) {

  let mobileSwiper = document.querySelector('.js-mobile-slider');
  let mobileFullSwiper = document.querySelector('.js-mobile-full-slider');

  const mobileSwiperParams = {
    slidesPerView: 1,
    loop: false,
    spaceBetween: 8,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      480: {
        slidesPerView: 2,
      }
    },
    on: {
      destroy: function() {
        $('.swiper-pagination').hide();
      },
      init: function() {
        $('.swiper-pagination').show();
      },
    },
  };

  const mobileFullSwiperParams = {
    slidesPerView: 1.4,
    loop: true,
    breakpoints: {
      480: {
        slidesPerView: 2,
      }
    },
  };

  if( $('.js-mobile-slider').length > 0 ) {

    mobileSlidersDisplay('.js-mobile-slider', mobileSwiperParams);

    $(window).resize(function() {
      mobileSlidersDisplay('.js-mobile-slider', mobileSwiperParams);
    });
  }

  if( $('.js-mobile-full-slider').length > 0 ) {
    mobileSlidersDisplay('.js-mobile-full-slider', mobileFullSwiperParams);

    $(window).resize(function() {
      mobileSlidersDisplay('.js-mobile-full-slider', mobileFullSwiperParams);
    });
  }

  function mobileSlidersDisplay(swiperSelector, swiperParams) {

    if( $(window).width() < 960) {

      if ( !mobileSwiper.initialized ) {
        mobileSwiper = new Swiper(swiperSelector, swiperParams);
      }

      else if ( !mobileFullSwiper.initialized ) {
        mobileFullSwiper = new Swiper(swiperSelector, swiperParams);
      }
    }

    else {

      if( mobileSwiper.initialized ) {
        mobileSwiper.destroy(false,true);
        return;
      } else {
        $('.swiper-pagination').hide();
      }

      if( mobileFullSwiper.initialized ) {
        mobileFullSwiper.destroy(false,true);
        return;
      }
    }
  }
}
